import { Autocomplete, AutocompleteProps, AutocompleteValue } from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC, ReactElement, useState } from 'react'

import { AutocompleteData, AutocompleteResult, NetworkAutocompleteOption } from './NetworkAutocompleteOption'

export const networkAutoCompleteTestId = 'network-autocomplete'

interface DataAttributes {
  [key: string]: string
}

export interface AutocompleteDataAttributes {
  input?: DataAttributes
}

export type NetworkAutocompleteProps = {
  getCompletions: (searchText: string) => Promise<AutocompleteResult[]>
  handleSelection: (selection: AutocompleteResult) => void
  handleClear?: () => void
  hasFooter?: boolean
  footerData?: AutocompleteData
  secondaryActionIcon?: ReactElement
  secondaryAction?: (selection: AutocompleteResult) => void
  defaultValue?: AutocompleteResult
  clearOnSelect?: boolean
  filterOptions?: AutocompleteProps['filterOptions']
  inputId?: string
  placeholder?: string
  onSearchTextChange?: (searchText: string) => void
  isDisabled?: boolean
  dataAttributes?: AutocompleteDataAttributes
}

export const NetworkAutocomplete: FC<NetworkAutocompleteProps> = ({
  defaultValue,
  clearOnSelect,
  onSearchTextChange,
  handleSelection,
  handleClear,
  placeholder = 'Select...',
  filterOptions = (x) => x,
  inputId,
  isDisabled,
  dataAttributes,
  getCompletions,
  hasFooter,
  footerData,
  secondaryAction,
  secondaryActionIcon,
}) => {
  // @ts-expect-error TS(2345) FIXME: Argument of type 'AutocompleteResult | undefined' ... Remove this comment to see the full error message
  const [value, setValue] = useState<AutocompleteResult>(defaultValue)

  const isFooter = (selection: AutocompleteResult): boolean => selection?.data?._id === 'footer'

  const handleChange = (option: unknown): void => {
    const newValue = option as AutocompleteResult
    // @ts-expect-error TS(2345) FIXME: Argument of type 'AutocompleteResult | null' is no... Remove this comment to see the full error message
    setValue(clearOnSelect || isFooter(newValue) ? null : newValue)
    if (onSearchTextChange) {
      onSearchTextChange('')
    }
    if (!isFooter(newValue) && newValue) {
      handleSelection(newValue)
    }
  }

  const dataService = async (str: string) => {
    let newCompletions: unknown[] = []
    const completions = await getCompletions(str)
    newCompletions = completions.map((completion) => ({
      ...completion,
      data: { ...completion.data, actionIcon: secondaryActionIcon, handleActionIconClick: secondaryAction },
    }))
    if (hasFooter && footerData) {
      newCompletions = [
        ...newCompletions,
        {
          label: 'footer',
          value: 'footer',
          data: footerData,
        },
      ]
    }

    return newCompletions as AutocompleteValue[]
  }

  return useObserver(() => (
    <div data-testid={networkAutoCompleteTestId}>
      <Autocomplete
        value={value && { text: value.label }}
        includeInputInList
        filterSelectedOptions
        filterOptions={filterOptions}
        renderOption={NetworkAutocompleteOption}
        onOptionSelect={handleChange}
        dataService={dataService}
        disabled={isDisabled}
        getOptionLabel={(option) => option.label ?? option.text ?? ''}
        getOptionSelected={(option, selectedValue) => option.label === selectedValue.text}
        freeSolo={false}
        onClean={() => handleClear && handleClear()}
        TextFieldProps={{
          id: inputId,
          placeholder,
          inputProps: dataAttributes?.input,
          margin: 'none',
        }}
      />
    </div>
  ))
}
